import { LogoMark } from "./logo"

/**
 * What the app shows while it waits on the server for the session or the workspace list (decision 0034): the mark
 * and "Loading…", centered like `RouteError`. The root, guest, app and home routes show it after 300 ms, so a slow
 * server is never a blank page; a failure or a timeout then ends in `RouteError`.
 */
export function AppPending() {
  return (
    <main
      role="status"
      aria-live="polite"
      className="flex min-h-dvh flex-col items-center justify-center gap-4 px-4 text-center"
    >
      <LogoMark />
      <p className="text-sm text-muted">Loading…</p>
    </main>
  )
}
